export default __webpack_public_path__ + "static/media/openIMIS.69f59b48.png";